import React, {Component} from 'react';
import { MenuItem, IconMenu } from "material-ui/IconMenu";
import {Link} from 'react-router-dom';
import ArrowDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import Authorization from '../containers/Authorization';
const styles = {
    linkStyle: {
      textDecoration: 'none',
      color: 'white'
    },
    buttonStyle: {
      cursor: 'pointer',
      border:'none',
      backgroundColor: 'transparent',
      color: 'white',
      fontFamily: 'Source Sans Pro',
      fontSize: 24,
      fontWeight: '600',
    },
    separator: {
      fontSize: '0.5em',
      position: 'relative',
      top: '-0.3em',
    },
    iconStyle: {
      top: 5,
      position: 'relative',
    }
  };


//Stupid workaround for React warning that onKeyboardFocus should not be applied to 'button' element,
/**
 * @augments {Component<{routeMap: any[], page: string}, {}>}
 */
class WrappedMenuButton extends Component{
  render() {
    const {routeMap, page, onKeyboardFocus, ...rest} = this.props; //Extract irrelevant properties from props so they are not applied to the child element.
    let text = routeMap[page]
    if (typeof routeMap[page] !== 'string') {
      text = routeMap[page].label;
    }
    return <button style={styles.buttonStyle} {...rest}>{text}<ArrowDown style={styles.iconStyle} color='#FFF'/></button>;
  }
}

const PageMenu = (props) => {
  let page = props.page || props.defaultRoute;
  const routeMap = props.routes;
  const basePath = props.basePath;

  const menuItems = Object.keys(routeMap).map(r => {
    let primaryText = routeMap[r];
    let MenuElement = MenuItem;

    if (typeof routeMap[r] !== 'string') {
      primaryText = routeMap[r].label;
      MenuElement = Authorization(routeMap[r].features, MenuItem);
    }
    console.log(primaryText, typeof primaryText);
    return (<MenuElement
      key={r}
      containerElement={
        <Link to={`${basePath}/${r}`}/>
      }
      primaryText={primaryText}
    />
  )});

  return (
    <IconMenu
      value={page}
      iconButtonElement={<WrappedMenuButton page={page} routeMap={routeMap}/>}
      targetOrigin={{horizontal: 'left', vertical: 'top'}}
      anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
    >
     {menuItems}
    </IconMenu>
 );
}

export default PageMenu;



// WEBPACK FOOTER //
// ./src/components/PageMenu.js